import Vue from 'vue';
import Router from 'vue-router';
import { ROLE_ADMIN, ROLE_OPERATOR } from './libs/enum';

const ALL = [ROLE_ADMIN, ROLE_OPERATOR];
const ADMIN = [ROLE_ADMIN];

Vue.use(Router);

export const ROUTER_INDEX = '/';
export const ROUTER_LOGIN = '/login';
export const ROUTER_FORGET = '/forget';
export const ROUTER_RESOURCE = '/resource';
export const ROUTER_LAYOUT = '/layout';
export const ROUTER_SITE = '/site';
export const ROUTER_INSTALL = '/install';
export const ROUTER_VERSION = '/version';
export const ROUTER_AGENT = '/agent';
export const ROUTER_USER = '/user';
export const ROUTER_LOG = '/log';
export const ROUTER_DEVICE = '/device';
export const ROUTER_AGENT_DEVICE = '/agent-device';
export const ROUTER_SITE_DEVICE = '/site-device';
export const ROUTER_INSTALL_DEVICE = '/install-device';
export const menu = [
    {
        index: '1',
        name: '巨幕管理',
        role: ALL,
        children: [
            {
                index: '1-1',
                name: '素材管理',
                role: ALL,
                path: ROUTER_RESOURCE,
                component: () => import('./views/resource'),
            },
            // {
            //     index: '1-2',
            //     name: '布局管理',
            //     role: ALL,
            //     path: ROUTER_LAYOUT,
            //     component: () => import('./views/layout')
            // }
        ],
    },
    {
        index: '2',
        name: '施工安装',
        role: ALL,
        children: [
            {
                index: '2-4',
                name: '设备列表',
                role: ADMIN,
                path: ROUTER_DEVICE,
                component: () => import('./views/device'),
            },
            {
                index: '2-1',
                name: '施工点管理',
                role: ADMIN,
                path: ROUTER_SITE,
                component: () => import('./views/site'),
            },
            {
                index: '2-2',
                name: '施工安装',
                role: ALL,
                path: ROUTER_INSTALL,
                component: () => import('./views/install'),
            },
            // {
            //     index: '2-3',
            //     name: '版本管理',
            //     role: ALL,
            //     path: ROUTER_VERSION,
            //     component: () => import('./views/version')
            // }
        ],
    },
    {
        index: '3',
        name: '代理商管理',
        role: ADMIN,
        children: [
            {
                index: '3-1',
                name: '代理商管理',
                role: ADMIN,
                path: ROUTER_AGENT,
                component: () => import('./views/agent'),
            },
        ],
    },
    {
        index: '4',
        name: '系统管理',
        role: ADMIN,
        children: [
            {
                index: '4-1',
                name: '用户管理',
                role: ADMIN,
                path: ROUTER_USER,
                component: () => import('./views/user'),
            },
            // {
            //     index: '4-2',
            //     name: '操作日志',
            //     role: ADMIN,
            //     path: ROUTER_LOG,
            //     component: () => import('./views/log')
            // }
        ],
    },
];

let routes = [];
menu.forEach(item => {
    routes = [...routes, ...item.children];
});
routes.unshift({
    path: ROUTER_INDEX,
    redirect: ROUTER_RESOURCE,
});

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: ROUTER_LOGIN,
            component: () => import('./views/login'),
        },
        {
            path: ROUTER_FORGET,
            component: () => import('./views/forget'),
        },
        {
            path: ROUTER_INDEX,
            component: () => import('./views/main'),
            children: routes,
        },
        {
            path: ROUTER_AGENT_DEVICE,
            component: () => import('./views/agent/device'),
        },
        {
            path: ROUTER_SITE_DEVICE,
            component: () => import('./views/site/device'),
        },
        {
            path: ROUTER_INSTALL_DEVICE,
            component: () => import('./views/install/device'),
        },
    ],
});

export default router;
